import React from 'react';
import PropTypes from 'prop-types';

const SEO = ({ title, description }) => {
  const pageTitle = title ? `Mutawir Studios | ${title}` : 'Mutawir Studios';

  return (
    <>
      <meta charSet="utf-8" />
      <title>{pageTitle}</title>
      <meta name="robots" content="index, follow" />
      {description && <meta name="description" content={description} />}
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    </>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

export default SEO;